
interface CacheEntry {
  count: number;
  timestamp: number;
  ttl: number;
}

/**
 * Manages caching for message-related data to improve performance
 */
export class MessageCache {
  private static cache: CacheEntry | null = null;
  private static readonly CACHE_TTL = 30000; // 30 seconds

  /**
   * Updates the cache with a new count and timestamp
   */
  static updateCache(count: number): void {
    this.cache = {
      count,
      timestamp: Date.now(),
      ttl: this.CACHE_TTL
    };
  }

  /**
   * Gets the cached count if still valid, otherwise returns null
   */
  static getCachedCount(): number | null {
    if (!this.cache) {
      return null;
    }

    if (Date.now() - this.cache.timestamp >= this.CACHE_TTL) {
      this.cache = null;
      return null;
    }

    return this.cache.count;
  }

  /**
   * Invalidates the current cache
   */
  static clearCache(): void {
    this.cache = null;
  }

  /**
   * Checks if cache is currently valid
   */
  static isCacheValid(): boolean {
    return this.cache !== null && Date.now() - this.cache.timestamp < this.CACHE_TTL;
  }
}
